export default "__VITE_ASSET__Deqult3x__"